// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 20px;
}
.row-block .logo-icon {
  height: 51px;
  width: 110px;
}
@media (min-width: 991px) {
  .row-block .logo-icon {
    height: 57px;
    width: 157px;
    padding: 10px;
  }
}
.row-block .home-click {
  cursor: pointer;
}
.row-block .width-20 {
  width: 25%;
  text-align: left;
}
.row-block .width-20:last-child {
  text-align: right;
}

#map {
  width: 100%;
  height: 100%;
}

.search-bar {
  border-radius: 4px;
  line-height: 1.6;
}

.search-bar > div {
  height: 100%;
  display: flex;
  flex-direction: row;
  place-items: center;
}

#search-container {
  top: 4px;
  left: 4px;
  right: 4px;
  position: absolute;
  padding: 4px;
}
#search-container app-venue-suggestion {
  width: 100%;
}

.slides-container {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
}

.swiper-slide {
  align-self: flex-end;
}

app-venue-suggestion {
  width: 90%;
}

.mode-icon {
  padding: 6px;
  height: 23px;
  width: 23px;
  border-radius: 1px;
}

.mode-icon {
  background: white;
  color: var(--ion-color-black);
  transition: 0.3s linear;
}

.mode-icon.selected {
  background: var(--ion-color-primary);
  color: white;
  transition: 0.3s linear;
}

.full-height {
  height: 100%;
}

.sidebar {
  overflow: auto;
  height: 100%;
}
.sidebar app-venue-suggestion {
  margin: 5px auto;
}
.sidebar .title {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.loading-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: black;
  opacity: 0.5;
}

.hint {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 14px;
  background: white;
}
.hint p {
  font-size: 12px;
  color: black;
  margin: 0;
  padding: 0 8px;
}
.hint span {
  font-size: 14px;
}
.hint ion-icon {
  height: 44px;
  width: 44px;
  place-self: center;
}

ion-header {
  background: var(--ion-color-secondary) center bottom/105% no-repeat !important;
}
ion-header .toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 75px;
  padding: 0px 20px;
}
ion-header .toolbar ion-img {
  width: 180px;
}
ion-header .toolbar .right-block {
  display: flex;
  justify-content: center;
  align-items: center;
}

.block-item {
  width: 100%;
  max-height: 190px;
}
.block-item ion-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/map/map.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAAD;AACC;EACC,YAAA;EACA,YAAA;AACF;ACRE;EDKD;IAIE,YAAA;IACA,YAAA;IACA,aAAA;EAGD;AACF;AADC;EACC,eAAA;AAGF;AAAC;EACC,UAAA;EACA,gBAAA;AAEF;AAAC;EACC,iBAAA;AAEF;;AACA;EACC,WAAA;EACA,YAAA;AAED;;AACA;EACC,kBAAA;EACA,gBAAA;AAED;;AACA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAED;;AACA;EACC,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;AAED;AAAC;EACC,WAAA;AAEF;;AAEA;EACC,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;AACD;;AAEA;EACC,oBAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,YAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AACD;;AAEA;EACC,iBAAA;EACA,6BAAA;EACA,uBAAA;AACD;;AAEA;EACC,oCAAA;EACA,YAAA;EACA,uBAAA;AACD;;AAEA;EACC,YAAA;AACD;;AAEA;EAKC,cAAA;EACA,YAAA;AAHD;AAFC;EACC,gBAAA;AAIF;AAEC;EACC,UAAA;EACA,iBAAA;EACA,kBAAA;AAAF;;AAIA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AADD;;AAIA;EACC,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AADD;AAGC;EACC,eAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;AADF;AAIC;EACC,eAAA;AAFF;AAKC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAHF;;AAOA;EACC,8EAAA;AAJD;AAMC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAJF;AAKE;EACC,YAAA;AAHH;AAKE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AAHH;;AAOA;EACC,WAAA;EACA,iBAAA;AAJD;AAKC;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAHF","sourcesContent":["@import '../../../theme/mixins';\n.row-block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 3px 20px;\n\t.logo-icon {\n\t\theight: 51px;\n\t\twidth: 110px;\n\t\t@include desktop {\n\t\t\theight: 57px;\n\t\t\twidth: 157px;\n\t\t\tpadding: 10px;\n\t\t}\n\t}\n\t.home-click {\n\t\tcursor: pointer;\n\t}\n\n\t.width-20 {\n\t\twidth: 25%;\n\t\ttext-align: left;\n\t}\n\t.width-20:last-child {\n\t\ttext-align: right;\n\t}\n}\n#map {\n\twidth: 100%;\n\theight: 100%;\n}\n\n.search-bar {\n\tborder-radius: 4px;\n\tline-height: 1.6;\n}\n\n.search-bar > div {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: row;\n\tplace-items: center;\n}\n\n#search-container {\n\ttop: 4px;\n\tleft: 4px;\n\tright: 4px;\n\tposition: absolute;\n\tpadding: 4px;\n\n\tapp-venue-suggestion {\n\t\twidth: 100%;\n\t}\n}\n\n.slides-container {\n\tposition: absolute;\n\tbottom: 20px;\n\tleft: 0;\n\tright: 0;\n}\n\n.swiper-slide {\n\talign-self: flex-end;\n}\n\napp-venue-suggestion {\n\twidth: 90%;\n}\n\n.mode-icon {\n\tpadding: 6px;\n\theight: 23px;\n\twidth: 23px;\n\tborder-radius: 1px;\n}\n\n.mode-icon {\n\tbackground: white;\n\tcolor: var(--ion-color-black);\n\ttransition: 0.3s linear;\n}\n\n.mode-icon.selected {\n\tbackground: var(--ion-color-primary);\n\tcolor: white;\n\ttransition: 0.3s linear;\n}\n\n.full-height {\n\theight: 100%;\n}\n\n.sidebar {\n\tapp-venue-suggestion {\n\t\tmargin: 5px auto;\n\t}\n\n\toverflow: auto;\n\theight: 100%;\n\n\t.title {\n\t\twidth: 90%;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n}\n\n.loading-container {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\tz-index: 10;\n\tbackground: black;\n\topacity: 0.5;\n}\n\n.hint {\n\tbox-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n\tborder-radius: 4px;\n\tpadding: 14px;\n\tbackground: white;\n\n\tp {\n\t\tfont-size: 12px;\n\t\tcolor: black;\n\t\tmargin: 0;\n\t\tpadding: 0 8px;\n\t}\n\n\tspan {\n\t\tfont-size: 14px;\n\t}\n\n\tion-icon {\n\t\theight: 44px;\n\t\twidth: 44px;\n\t\tplace-self: center;\n\t}\n}\n\nion-header {\n\tbackground: var(--ion-color-secondary) center bottom/105% no-repeat !important;\n\n\t.toolbar {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmin-height: 75px;\n\t\tpadding: 0px 20px;\n\t\tion-img {\n\t\t\twidth: 180px;\n\t\t}\n\t\t.right-block {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t}\n\t}\n}\n.block-item {\n\twidth: 100%;\n\tmax-height: 190px;\n\tion-img {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tobject-fit: cover;\n\t}\n\t// overflow: hidden;\n}\n\n// ion-content ion-row {\n// \twidth: 100%;\n// \tdisplay: flex;\n// \tjustify-content: center;\n// }\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
